import React ,{useEffect} from 'react';
import { useHistory } from "react-router-dom";

import { initGA, PageView } from 'utils/googleAnalytics.js';

export default function GoogleAnalytics(props) {
	const anayticsID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
	const history = useHistory();
	const sendPageViewInfo = () =>{
		PageView();
	}
	

	/*Dynamic import asset checker*/
	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(()=>{
		if (process.env.NODE_ENV === 'production'){
			initGA(anayticsID);
			 history.listen((location, action) => {  
				sendPageViewInfo();
			});
		}
		
	},[]);

	return (
		<>
		</>
	);
}